import { format, parse } from 'date-fns';

export const emptyLongDash = '—';

export const getDate = (date) => {
  if (!date) return emptyLongDash;
  const parsedDate =
    date && typeof date === 'string'
      ? parse(date, 'yyyy-MM-dd', new Date())
      : date;

  return `${format(parsedDate, 'MM/dd/yyyy')}`;
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return emptyLongDash;
  const date = new Date(timestamp);
  // yields 2/8/2021 at 12:00 PM
  return `${getDate(date)} at ${format(date, 'h:mm aaa')}`;
};

export const formatSplitTimestamp = (timestamp) => {
  if (!timestamp)
    return {
      day: emptyLongDash,
      time: emptyLongDash,
    };

  const date = new Date(timestamp);

  return {
    day: getDate(date),
    time: format(date, 'h:mm aaa'),
  };
};
